<template lang="pug">
  v-card.round-xl.pa-4.mb-3(outlined)
    redeem-offer-item-property(:item="offer")
</template>

<script>
import RedeemOfferItemProperty from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferItemProperty.vue";

export default {
  components: {
    RedeemOfferItemProperty
  },
  props: {
    offer: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style scoped>
</style>